<template>
	<div :class="{ 'has-notice': !!notice }" id="app">

		<component :is="$route.meta.layout"></component>

		<site-footer v-if="isFooterVisible"></site-footer>
		<notifications group="app" position="bottom right" />
		<!-- <expired-info
			:plan="user.package"
			:expired-date="user.expired_date"
			v-if="user"
		/> -->
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import Footer from './components/Footer.vue';
// import AppNotice from './components/AppNotice.vue';
// import Announcements from './components/Announcements.vue';
// import ExpiredInfo from './components/ExpiredInfo.vue';
// import { duplicateVar } from './lib/helper';
import billingsApi from '@/api/billings';
import homepageApi from '@/api/homepage';
import submissionApi from '@/api/submissions';
import settingApi from '@/api/setting';
import userApi from '@/api/user';
import { getBlacklistedProducts } from '@/api/products';
import { storefrontAddonId } from './lib/statics';
import Admin from '@/views/layouts/Admin.vue';
import Main from '@/views/layouts/Main.vue';

export default {
	name: 'App',
	components: {
		'site-footer': Footer,
		// AppNotice,
		// Announcements,
		// ExpiredInfo,
		// SuperNavInventro,
		Admin,
		Main,
	},
	sockets: {
		connect() {
			console.log('[Socket] Connected');
			if (this.user) {
				this.initSocketSubs();
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isOwner: 'isOwner',
			settings: 'settings',
			isLoggedIn: 'isLoggedIn',
			isSupplier: 'isSupplier',
			isDropshipper: 'isDropshipper',
			isRoleAdmin: 'isRoleAdmin',
			isHasUsername: 'isHasUsername',
			isHasBankAccounts: 'isHasBankAccounts',
			isRightbarVisible: 'isRightbarVisible',
			notice: 'notice',
			billingsCount: 'billingsCount',
			billingsDueCount: 'billingsDueCount',
			limitedStockProductIds: 'limitedStockProductIds',
			isExpired: 'isExpired',
			isAdmin: 'isAdmin',
			appName: 'appName',
			appProject: 'appProject',
			intercomHmac: 'intercomHmac',
			googleAnalyticsKey: 'googleAnalyticsKey',
		}),
		isFooterVisible() {
			const is404 = this.$route.matched[0]?.path === '*';
			const is403 = this.$route.path === '/403';
			return !is403 && !is404
					&& this.isLoggedIn
					&& this.$route.path.indexOf('/products/') === -1
					&& this.$route.path.indexOf('/auth/callback') === -1
					&& this.$route.name !== 'home'
					&& this.$route.name !== 'search'
					&& !this.isAdminArea
					&& this.$route.name !== 'payment-success'
					&& this.$route.name !== 'product-detail'
					&& this.$route.name !== 'phoneVerification'
					&& this.$route.name !== 'wholesale-order-checkout'
					&& this.$route.name !== 'thank-you'
					&& this.$route.name !== 'payment-confirmation';
		},
		isAdminArea() {
			return this.$route.path.includes('admin');
		},
	},
	methods: {
		...mapActions({
			fetchUser: 'fetchUser',
			setSettings: 'setSettings',
			fetchNotice: 'fetchNotice',
			fetchAnnouncements: 'fetchAnnouncements',
			toggleAnnouncements: 'toggleAnnouncements',
			setEmbedVersion: 'setEmbedVersion',
			setBillingsCount: 'setBillingsCount',
			setBillingsDueCount: 'setBillingsDueCount',
			setLimitedStockProductIds: 'setLimitedStockProductIds',
			setRangeStockCheckedProductsCount: 'setRangeStockCheckedProductsCount',
			setStockCheckedProductsCount: 'setStockCheckedProductsCount',
			setCancelledSubmissionIds: 'setCancelledSubmissionIds',
			setStorefrontStatus: 'setStorefrontStatus',
			setBlacklistedProductIds: 'setBlacklistedProductIds',
			setGoogleAnalyticsKey: 'setGoogleAnalyticsKey',
			setMetaPixels: 'setMetaPixels',
		}),
		initData() {
			// Fetch user if logged in
			if (this.isLoggedIn && !this.user) {
				this.fetchUser();
			}
			if (this.user) {
				this.onUserLoaded();
			}
		},
		onUserLoaded() {
			const params = { type: 'notice', limit: 1, is_active: true, visibility: this.user.owner_type };
			if (this.$socket.connected) {
				this.initSocketSubs();
			}
			this.moment.locale(this.user.locale);
			this.fetchAppInfo();
			// this.initIntercom();
			// disable per 31 Jan 2025
			// this.setChatWootUser()
			this.fetchNotice(params);

			params.visibility = 'public';
			this.fetchNotice(params);

			this.fetchAnnouncements();

			if (!this.isAdmin) {
				// billing only for seller
				if (this.isDropshipper) {
					this.fetchBillings();
					this.getDueBillingsCount();
				}
				if (this.isSupplier) {
					this.fetchLimitedStockProducts();
					this.fetchRangeStockCheckedProductsCount();
					this.fetchStockCheckedProductsCount();
					this.fetchCancelledSubmissions();
				}
			}
			// this.checkExpired();
			// this.fetchStorefrontStatus();
			// this.initSurveyMonkey();
			if (this.isDropshipper) {
				this.fetchBlacklistedProducts();
			}
		},
		initSocketSubs() {
			console.log('[Socket] Init Subscribe');
			const userId = this.user._id;
			// Global Channel
			this.$socket.client.emit('subscribe', 'global');
			// Other Channels
			const channels = this.getSocketChannels(userId);
			for (let index = 0; index < channels.length; index++) {
				const channel = channels[index];
				this.$socket.client.emit('subscribe', channel);
			}
		},
		getSocketChannels(userId) {
			const prefixes = ['user', 'order'];
			const channels = prefixes.map(prefix => `${prefix}_${userId}`);
			return channels;
		},
		fetchAppInfo() {
			// const callback = (response) => {
			// 	const app = response.data;
			// 	this.setEmbedVersion(app.embedVersion);
			// };
			// const errorCallback = () => {};
			// appApi.getInfo(callback, errorCallback);
		},
		initIntercom() {
			const userId = this.user._id;
			const name = this.user.name;
			const username = this.user.username;
			const email = this.user.email;
			const phone = this.user.phone;
			const plan = this.user.package;
			const createdAt = this.user.created_at;
			const role = this.user.role;
			const expiredDate = this.user.expired_date;
			const level = this?.user?.level ?? 'regular';

			const companyId = role === 'owner' ? userId : this.user.parent_id;
			const store = this.user.store;
			const companyName = store ? store.name : '';
			const companyPhone = store ? store.phone : '';
			const companyEmail = store ? store.email : '';
			const companyWebsite = store ? store.website : '';
			const companyFacebook =				store
				&& store.social_media_accounts
				&& store.social_media_accounts.facebook
				? store.social_media_accounts.facebook
				: '';
			const companyInstagram =				store
				&& store.social_media_accounts
				&& store.social_media_accounts.instagram
				? store.social_media_accounts.instagram
				: '';

			const company = {
				id: companyId,
				name: companyName,
				phone: companyPhone,
				email: companyEmail,
				website: companyWebsite,
				facebook: companyFacebook,
				instagram: companyInstagram,
			};

			if (role === 'owner') {
				company.created_at = createdAt;
				company.plan = plan;
				company.level = level;
			}

			const intercomSettings = {
				app_id: 'ryq573si',
				user_id: userId,
				name,
				email,
				phone,
				created_at: createdAt,
				username,
				plan,
				role,
				expired_date: expiredDate,
				// account_role: role,
				company,
				user_hash: this.intercomHmac,
			};

			const hasFeatures =	this.user && this.user.features && this.user.features.length > 0;
			if (hasFeatures) {
				const features = this.user.features;
				const isHasShipmentBankTransfer = features.includes(
					'shipment_bank_transfer',
				);
				intercomSettings.feature_shipment_bank_transfer = isHasShipmentBankTransfer;
			}

			if (window.Intercom) {
				window.Intercom('boot', intercomSettings);
			}
		},
		initIntercomGuest() {
			const intercomSettings = {
				app_id: 'ryq573si',
			};

			if (window.Intercom) {
				window.Intercom('boot', intercomSettings);
			}
		},
		initAmplitude() {
			if (this.$amplitude) {
				const userId = this.user._id;
				const props = {
					name: this.user.name,
					role: this.user.role,
					plan: this.user.package,
				};
				this.$amplitude.setUserId(userId);
				this.$amplitude.setUserProperties(props);
			}
		},
		fetchBillings() {
			const callback = (response) => {
				const count = response.data;
				this.setBillingsCount(count);
			};
			billingsApi.getOutstandingsCount(callback);
		},
		fetchLimitedStockProducts() {
			const callback = (response) => {
				const limitedProductIds = response.data;
				this.setLimitedStockProductIds(limitedProductIds);
			};
			homepageApi.getLimitedStockProductIds(callback);
		},
		fetchRangeStockCheckedProductsCount() {
			const callback = (response) => {
				const count = response.data;
				this.setRangeStockCheckedProductsCount(count);
			};
			homepageApi.getRangeStockCheckedProducts(callback);
		},
		fetchStockCheckedProductsCount() {
			const callback = (response) => {
				const count = response.data;
				this.setStockCheckedProductsCount(count);
			};
			homepageApi.getStockCheckedProducts(callback);
		},
		fetchCancelledSubmissions() {
			const callback = (response) => {
				const setCancelledSubmissionIds = response.data;
				this.setCancelledSubmissionIds(setCancelledSubmissionIds);
			};
			submissionApi.getCancelledSubmissionIds(callback);
		},
		getDueBillingsCount() {
			const callback = (response) => {
				const count = response.data;
				this.setBillingsDueCount(count);
				const isToPaymentConfirmation = this.$route.path === '/payment-confirmation';
				const isToPaymentSuccess = this.$route.path === '/payment-success';
				const isToBilling = this.$route.path === '/billings';
				if (count > 0 && this.isOwner && !(isToPaymentConfirmation || isToPaymentSuccess || isToBilling)) {
					this.$router.push('/billings');
				}
			};
			const errorCallback = () => {};
			billingsApi.getDueBillingsCount(callback, errorCallback);
		},
		checkExpired() {
			if (this.isExpired && !this.isSupplier) {
				this.$router.push('/plans');
			}
		},
		fetchStorefrontStatus() {
			const addonId = storefrontAddonId; // Storefront
			const callback = (response) => {
				const isActive = response.data.is_active;
				this.setStorefrontStatus(isActive);
			};
			userApi.getAddonStatus(addonId, callback);
		},
		initSurveyMonkey() {
			const userJoinDateString = this.user.created_at;
			const userJoinDate = dayjs.utc(userJoinDateString, 'YYYY-MM-DD HH:mm:ss');
			const now = dayjs();
			const diff = now.diff(userJoinDate, 'day');
			const isNewUser = diff < 25;
			const scriptTag = document.getElementById('survey-monkey-script');
			if (!isNewUser && scriptTag) {
				const theScript =					'(function(t,e,s,o){var n,c,l;t.SMCX=t.SMCX||[],e.getElementById(o)||(n=e.getElementsByTagName(s),c=n[n.length-1],l=e.createElement(s),l.type="text/javascript",l.async=!0,l.id=o,l.src="https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgd4gQTEyMMz59PUHr05H3wUTdp6oQgNTMp7y07MlV8yCG.js",c.parentNode.insertBefore(l,c))})(window,document,"script","smcx-sdk");';
				scriptTag.innerHTML = theScript;
			}
		},
		initWatZapLiveChat() {
			const isProduction = process.env.VUE_APP_ENV === 'production';
			if (isProduction) {
				const watZapScript = document.createElement('script');
				watZapScript.setAttribute('src', 'https://cdn.watzap.id/widget-api.js');
				watZapScript.setAttribute('data-watzapkey', 'HYXG1279');
				watZapScript.setAttribute('async', '');
				document.head.appendChild(watZapScript);
			}
		},
		initMekariQontak() {
			const qontakScript = document.createElement('script');
			qontakScript.setAttribute('src', 'https://qontak.com/wp-content/themes/qontak/assets/scripts/parts/wa-button.js');
			qontakScript.setAttribute('async', '');
			qontakScript.setAttribute('onLoad', "whatsappWidget({ buttonName: 'Chat', brandImage: 'https://qontak.com/wp-content/uploads/images-widget/whatsapp-6812-widget.png', brandName: 'Ostock', brandSubtitleText: 'Jualan Online Tanpa Modal', buttonSize: 'small', callToAction: 'Start chat', phoneNumber: '6285280009936', welcomeMessage: 'Halo 👋, Saya ingin mengetahui informasi lebih lanjut tentang Ostock',})");
			document.body.appendChild(qontakScript);

			if (window.Intercom) {
				window.Intercom('update', { hide_default_launcher: true });
			}
		},
		initChatwoot() {
			const chatwootScript = document.createElement('script');
			chatwootScript.setAttribute('src', 'https://chatwoot.ordivo.id/packs/js/sdk.js');
			chatwootScript.setAttribute('defer', '');
			chatwootScript.setAttribute('async', '');
			chatwootScript.onload = () => {
				window.chatwootSettings = {
					position: 'right',
					type: 'standard',
					launcherTitle: 'Chat with us',
				};
				window.chatwootSDK.run({
					websiteToken: 'LHWZiG5wrkzZq2ktxQDpkd2a',
					baseUrl: 'https://chatwoot.ordivo.id',
				});
			};
			document.body.appendChild(chatwootScript);

			window.addEventListener('chatwoot:error', (e) => {
				console.log('[Chatwoot] Error', e);
			});

			window.addEventListener('chatwoot:ready', () => {
				console.log('[Chatwoot] Ready');
			});
		},
		setChatWootUser() {
			const chatwootHmac = this.chatwootHmac;

			const chatwootUser = {
				email: this.user.email,
				name: this.user.name,
				phone_number: this.user.phone,
				identifier_hash: chatwootHmac,
			};

			if (this.user.picture && this.user.picture !== '') {
				chatwootUser.avatar_url = this.user.picture;
			}

			if (window.$chatwoot) {
				window.chatwootSDK.run({
					websiteToken: 'LHWZiG5wrkzZq2ktxQDpkd2a',
					baseUrl: 'https://chatwoot.ordivo.id',
				});
				window.$chatwoot.setUser(this.user._id, chatwootUser);
			}
		},
		fetchBlacklistedProducts() {
			const callback = (response) => {
				const blacklistedProductIds = response.data ?? [];
				this.setBlacklistedProductIds(blacklistedProductIds);
			};
			const errorCallback = () => {};
			getBlacklistedProducts(callback, errorCallback);
		},
		getGoogleAnalyticsKey() {
			const callback = (response) => {
				const key = response.data;
				this.setGoogleAnalyticsKey(key);
				this.initGoogleAnalytics();
			};
			const errorCallback = () => {};
			settingApi.getGoogleAnalyticsKey(callback, errorCallback);
		},
		getMetaPixels() {
			const callback = (response) => {
				const key = response.data;
				this.setMetaPixels(key);
			};
			const errorCallback = () => {};
			settingApi.getMetaPixels(callback, errorCallback);
		},
		initGoogleAnalytics() {
			const key = this.googleAnalyticsKey;
			if (key) {
				const url = `https://www.googletagmanager.com/gtag/js?id=${key}`;
				const googleAnalyticsScript = document.createElement('script');
				googleAnalyticsScript.setAttribute('src', url);
				googleAnalyticsScript.setAttribute('async', '');
				document.head.appendChild(googleAnalyticsScript);

				const googleAnalyticsConfigScript = document.createElement('script');
				googleAnalyticsConfigScript.innerHTML = `
					window.dataLayer = window.dataLayer || [];
					function gtag(){dataLayer.push(arguments);}
					gtag('js', new Date());

					gtag('config', '${key}');`;
				document.head.appendChild(googleAnalyticsConfigScript);
			}
		},
	},
	created() {
		this.initData();
		// disable per 31 Jan 2025
		// this.initChatwoot();
	},
	mounted() {
		// if (!this.user) {
		// 	setTimeout(() => {
		// 		this.initIntercomGuest();
		// 	}, 500);
		// }
		// this.initWatZapLiveChat();
		// this.initMekariQontak();
		this.getGoogleAnalyticsKey();
		this.getMetaPixels();
	},
	watch: {
		$route(to, from) {
			// if (window.Intercom) {
			// 	window.Intercom('update');
			// }
			const isToBilling = to.path === '/billings';

			if (from.path === '/login' && to.path === '/') {
				this.initData();
			}
			if (this.billingsDueCount > 0 && this.isOwner && !isToBilling) {
				const isToPaymentConfirmation = from.path === '/billings' && to.path === '/payment-confirmation';
				const isToPaymentSuccess = from.path === '/payment-confirmation' && to.path === '/payment-success';

				if (!(isToPaymentConfirmation || isToPaymentSuccess)) {
					this.$router.push('/billings');
				}
			}
			if (this.isExpired && !this.isSupplier && to.path !== '/billings' && to.path !== '/login' && to.path !== '/logout' && to.path !== '/payment-confirmation' && to.path !== '/payment-success') {
				this.$router.push('/billings');
			}
		},
		user() {
			if (this.user) {
				this.onUserLoaded();
			}
		},
	},
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
@import url('https://cdn-uicons.flaticon.com/uicons-regular-rounded/css/uicons-regular-rounded.css');
// @import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.8.3/font/bootstrap-icons.css");
@import url("https://cdnjs.cloudflare.com/ajax/libs/bootstrap-icons/1.11.1/font/bootstrap-icons.min.css");
@import './assets/scss/base.scss';
</style>
